import { define, s, ui, when } from '@owenscorning/pcb.alpha';

import Renderer, { CONTRACTOR_LEVELS, LOCATION_MODES, SOURCE_MODES } from '../../../../OC/PageBuilder/FindAContractor';

const isNearby = when`../sourceMode`.is.equal.to(SOURCE_MODES.nearby);
const isSpecific = when`../sourceMode`.is.equal.to(SOURCE_MODES.specific);

export default define`Find A Contractor`('1.0.0')({
  thumbnail: ui`Modules/Page/Thumbnails/FindAContractorMini`,
  category: ui`Modules/Categories/Page/Customizable`,
  // eslint-disable-next-line react/jsx-props-no-spreading
  view: ({ value }) => <Renderer {...value} isEditor={Boolean(Board.editable)} />,
  edit: {
    heading: ui`Text`({
      label: 'Heading',
      default: 'Find a contractor',
    }),
    bodyCopy: ui`Text`({
      label: 'Body Copy',
      default: 'Get your roof installed by a contractor near {city}, {region}',
    }),
    [s._]: ui`Tip`.of('Interpolation is enabled. Use "{city}" and "{region}".'),
    notFoundCopy: ui`Text`({
      label: 'No contractors found copy',
      default: "We're sorry, we did not find any contractors in your area.",
    }),
    ctaLabel: ui`Text`({
      label: 'CTA Label',
      default: 'View More Contractors',
    }),
    ctaLink: ui`Text`({
      label: 'CTA Link',
      default: 'https://www.owenscorning.com/roofing/contractors',
    }),
    sourceMode: ui`Choices`.of({
      [SOURCE_MODES.nearby]: 'Nearby Contractors',
      [SOURCE_MODES.specific]: 'Specific Contractor Profiles',
    })({
      label: 'Contractor Source',
      mode: ui`Choices/Mode/Dropdown`,
      default: SOURCE_MODES.nearby,
    }),
    locationMode: ui`Choices`.of({
      [LOCATION_MODES.visitor]: 'Use Visitor Location',
      [LOCATION_MODES.postal]: 'Use Postal Code',
    })({
      label: 'Location',
      mode: ui`Choices/Mode/Dropdown`,
      default: LOCATION_MODES.visitor,
      visible: isNearby,
    }),
    postalCode: ui`Text`({
      label: 'Postal Code',
      visible: when`../sourceMode`.is.equal.to(SOURCE_MODES.nearby).and.when`../locationMode`.is.equal.to(
        LOCATION_MODES.postal
      ),
    }),
    previewPostalCode: ui`Text`({
      label: 'Preview Postal Code',
      default: '90210',
      tip: 'Used only for the Page Builder preview when visitor location is selected.',
      visible: when`../sourceMode`.is.equal.to(SOURCE_MODES.nearby).and.when`../locationMode`.is.equal.to(
        LOCATION_MODES.visitor
      ),
    }),
    radius: ui`Choices`.of({
      20: '20 miles',
      50: '50 miles',
      100: '100 miles',
    })({
      label: 'Radius',
      mode: ui`Choices/Mode/Dropdown`,
      default: 20,
      visible: isNearby,
    }),
    showOnlyWithLogos: ui`Switch`({
      label: 'Only show contractors with logos',
      default: true,
      visible: isNearby,
    }),
    contractorLevels: ui`Choices`.of({
      [CONTRACTOR_LEVELS.platinumPreferred]: 'Platinum Preferred',
      [CONTRACTOR_LEVELS.preferred]: 'Preferred',
    })({
      label: 'Contractor Level',
      mode: ui`Choices/Mode/Vertical`,
      multiple: true,
      default: [],
      tip: 'Leave both unselected to show all contractor levels.',
      visible: isNearby,
    }),
    badges: ui`Choices`.of({
      financing: 'Financing Available',
      awardWinner: 'Award Winner',
      recycling: 'Shingle Recycling Pledge',
      solar: 'Solar PROtect Certified',
      topOfHouse: 'Top of the House Certified',
      sureNail: 'SureNail Trained',
      tprs: 'TPRS Trained',
    })({
      label: 'Contractor Badges',
      mode: ui`Choices/Mode/Vertical`,
      multiple: true,
      default: [],
      visible: isNearby,
    }),
    contractorUrl1: ui`Text`({
      label: 'Contractor Profile URL 1',
      visible: isSpecific,
    }),
    contractorUrl2: ui`Text`({
      label: 'Contractor Profile URL 2',
      visible: isSpecific,
    }),
    contractorUrl3: ui`Text`({
      label: 'Contractor Profile URL 3',
      visible: isSpecific,
    }),
  },
});
